import axios from 'axios' //引入axios
// import qs from 'qs' //引入qs，用来序列化post类型的数据，否则后端无法接收到数据
// 设置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.headers['app_id'] = 'com.supertools.dailynews'
axios.defaults.withCredentials = false //在跨域请求时，不会携带用户凭证；返回的 response 里也会忽略 cookie

//创建axios实例，请求超时时间为300秒
const instance = axios.create({
	timeout: 300000,
	baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
})

//请求和响应拦截可以根据实际项目需求进行编写
// 请求发起前拦截
instance.interceptors.request.use(
	(request) => {
		//这里可以对接口请求头进行操作 如：request.headers['X-Token'] = token
		request.headers = { ...request.header }
		return request
	},
	(error) => {
		return Promise.reject(error)
	},
)

// 响应拦截（请求返回后拦截）
instance.interceptors.response.use(
	(response) => {
		return response.data
	},
	(error) => {
		return Promise.reject(error)
	},
)

//按照请求类型对axios进行封装
const service = {
	get(url, data) {
		// 简化为直接发送到Node代理，url作为查询参数传递
		return instance.get('/api-proxy', {
			params: {
				url, // 传递原始URL
				...data, // 直接传递其他参数
			},
		})
	},
	post(url, obj) {
		// 简化为直接发送到Node代理，url作为查询参数传递
		return instance.post(`/api-proxy?url=${url}`, obj)
	},
}
export { service }
